// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__42cD0","text":"Logo_text__EcpGp","abbr":"Logo_abbr__Tpvl7","year":"Logo_year__uBuW1","mainText":"Logo_mainText__6c7Rg"};